import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const label = (p) => `${p.shirt_number ?? "–"} ${p.last_name || p.public_name || p.first_name || ""}`.trim();

export function ScorerPicker({ tid, m, score, scorers, onChange }) {
  const [players, setPlayers] = useState(m.players || null);
  useEffect(() => {
    if (players) return;
    Promise.all(["home", "away"].map((s) => api.get(`/tournaments/${tid}/players`, { params: { team_id: m[s].id } }).then((r) => r.data))).then(([home, away]) => setPlayers({ home, away })).catch(() => setPlayers({ home: [], away: [] }));
  }, [players, tid, m]);
  if (!players) return <p className="text-xs text-fsl-slate">Carico le rose…</p>;
  const total = (side) => (players[side] || []).reduce((n, p) => n + (scorers[p.id] || 0), 0);
  const tap = (side, pid) => {
    const cur = scorers[pid] || 0;
    const next = total(side) < (Number(score[side]) || 0) ? cur + 1 : 0;
    const out = { ...scorers };
    if (next) out[pid] = next; else delete out[pid];
    onChange(out);
  };
  return (
    <div className="grid sm:grid-cols-2 gap-3" data-testid={`scorer-picker-${m.id}`}>
      {["home", "away"].map((side) => {
        const goals = Number(score[side]) || 0;
        const done = total(side);
        return (
          <div key={side} className="space-y-1.5">
            <div className="flex items-center justify-between text-[10px] uppercase tracking-wider text-fsl-slate"><span className="truncate">{m[side].club?.short_name || m[side].name}</span><span className={`num ${done === goals ? "text-fsl-success" : "text-fsl-gold"}`} data-testid={`scorer-count-${side}-${m.id}`}>{done}/{goals} gol</span></div>
            {goals === 0 ? <p className="text-[11px] text-fsl-slate">Nessun gol da assegnare</p> : (players[side] || []).filter((p) => p.status !== "inactive").length === 0 ? <p className="text-[11px] text-fsl-slate">Rosa vuota</p> : (
              <div className="flex flex-wrap gap-1.5">
                {(players[side] || []).filter((p) => p.status !== "inactive").map((p) => {
                  const n = scorers[p.id] || 0;
                  return <button key={p.id} type="button" onClick={() => tap(side, p.id)} className={`h-8 px-2.5 rounded-full text-xs font-semibold border transition-colors ${n ? "bg-fsl-gold text-ink-950 border-fsl-gold" : "border-white/15 text-fsl-slate hover:text-fsl-white hover:border-fsl-gold/60"}`} aria-pressed={n > 0} data-testid={`scorer-${p.id}`}>{label(p)}{n > 0 && <span className="ml-1.5 inline-flex items-center justify-center h-5 min-w-5 px-1 rounded-full bg-ink-950 text-fsl-gold num text-[10px]">{n > 1 ? `×${n}` : "⚽"}</span>}</button>;
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
